import { render, staticRenderFns } from "./CompanyCandidates.vue?vue&type=template&id=2e408971&scoped=true&"
import script from "./CompanyCandidates.vue?vue&type=script&lang=js&"
export * from "./CompanyCandidates.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCandidates.vue?vue&type=style&index=0&id=2e408971&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e408971",
  null
  
)

export default component.exports